module.exports = "https://cdn-assessment.mathletics.com/app/116/assets/images/a63532951be25d8635e4dba286aec217.svg";